export default {
  title: 'Importo minimo di pagamento: I pagamenti non possono essere tra {{rangeStart}} - {{rangeEnd}}',
  description: "Eccezione: Se hai un articolo gratuito puoi completare l'ordine con un totale di {{amount}}.",
};
